import { useLocationById } from '@hakimo-ui/hakimo/data-access';
import {
  FullScreenExitIcon,
  FullScreenIcon,
  ImagePopup,
  QueryResult,
} from '@hakimo-ui/hakimo/ui-elements';
import { useFullscreen } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useRef } from 'react';

interface Props {
  locationId: string;
}

export function Floorplan(props: Props) {
  const { locationId } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const queryResult = useLocationById(locationId);

  const { isFullScreen, toggleFullScreen } = useFullscreen(containerRef);

  return (
    <div
      ref={containerRef}
      className="dark:bg-ondark-bg-1 bg-onlight-bg-1 group min-h-[15rem] rounded-lg p-2"
    >
      <QueryResult queryResult={queryResult}>
        {(location) => (
          <>
            <div className="flex items-center justify-between">
              <h2 className="flex h-9 items-center pl-1 font-bold">
                Location Floorplan
              </h2>
              <ImagePopup
                imageUrl={queryResult.data?.floor_plan ?? ''}
                icon={<ArrowTopRightOnSquareIcon className="h-5 w-5" />}
                altText="Floorplan"
              />
            </div>
            {location.floor_plan ? (
              <div className="group relative flex max-h-[48rem] justify-center bg-gray-200 dark:bg-gray-900">
                <div className="invisible absolute right-0 top-0 group-hover:visible">
                  <Button
                    variant="icon"
                    onClick={toggleFullScreen}
                    className="dark:bg-ondark-bg-3 bg-onlight-text-3 enabled:hover:bg-ondark-bg-2 focus:ring-offset-0"
                  >
                    {isFullScreen ? (
                      <FullScreenExitIcon className="fill-dark-text h-7 w-7" />
                    ) : (
                      <FullScreenIcon className="fill-dark-text h-7 w-7" />
                    )}
                  </Button>
                </div>

                <img
                  src={location.floor_plan}
                  alt="Floorplan"
                  className={clsx(
                    isFullScreen ? 'max-h-[100vh]' : 'max-h-[48rem]'
                  )}
                />
              </div>
            ) : (
              <div className="flex h-96 items-center justify-center rounded-lg bg-blue-500/10">
                <span className="text-sm text-blue-400 dark:text-blue-200">
                  No floorplan available
                </span>
              </div>
            )}
          </>
        )}
      </QueryResult>
    </div>
  );
}

export default Floorplan;
